import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ClientService } from '../services/client.service';
import { UtilitiesService } from '../services/utilities.service';
import { map, tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export const clientStatusSplashResolver: ResolveFn<any> = () => {
  const clientSvc = inject(ClientService);
  const utils = inject(UtilitiesService);

  return clientSvc.fetchAll(1, 9999, 'fdClientId', 'asc', '').pipe(
    tap((res: any) => {
      const data = res?.data ?? [];
      const hasOnboarding = data.some(
        (c: any) => String(c?.status || '').toLowerCase() === 'onboarding'
      );

      const isFd = utils.isFdUserValue === true;

      if (!isFd && hasOnboarding) {
        utils.showOnboardingSplash();
      } else {
        utils.hideOnboardingSplash();
      }
    }),
    map(res => res),
    catchError(err => {
      utils.hideOnboardingSplash();
      return of({ data: [], meta: { total: 0 }, error: true, err });
    })
  );
};
